module.exports = __webpack_public_path__ + "static/iuspublik-bb34595990b1cd47a45ee2a1aaf8b872.jpg";